<main class="container-fluid">
  <app-admin-sidebar></app-admin-sidebar>
  <div class="events-container gap-3">
    <div class="w-100" *ngIf="user">
      <h1 class="subtitle">Activiteitoverzicht</h1>
      <h3 class="gray-text">In onderstaande tabel kun je de activiteiten van de website beheren.</h3>
      <div class="input-group input-shadow my-3">
        <div class="input-group-prepend">
          <span class="input-group-text search-icon"><i class="bi bi-search"></i></span>
        </div>
        <input type="text" class="form-control search-input shadow-none" placeholder="Zoek op naam"  [(ngModel)]="searchTerm">
      </div>
      <div class="table-container input-shadow mt-3">
        <table class="event-details">
          <thead>
          <tr>
            <td>Naam</td>
            <td>Adres</td>
            <td>Categorie</td>
            <td>Begin</td>
            <td>Einde</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let retrievedEvent of nameFilter(events)">
            <td>{{ retrievedEvent.name }}</td>
            <td class="gray-text">{{ retrievedEvent.address.streetName }} {{ retrievedEvent.address.houseNumber}}, {{ retrievedEvent.address.zipcode }}</td>
            <td class="gray-text">{{ retrievedEvent.category }}</td>
            <td class="gray-text">{{ retrievedEvent.start.toMillis() | date:'d MMM H:mm' }}</td>
            <td class="gray-text">{{ retrievedEvent.end.toMillis() | date:'d MMM H:mm'  }}</td>
            <td (click)="navigateToEvent(retrievedEvent.id)"><i class="bi bi-chevron-right"></i></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</main>



